<script>


export let data, visible, colors, hoverLabel = true, single;

function handleMouseOver(e) {

const laName = d3.select(this).attr("name")
const xPosition = single ? d3.select(this).attr("cx") : 0;

d3.select(this.parentNode.parentNode).selectAll(".node").attr("opacity", function(d,i) {return d3.select(this).attr("name") == laName ? 1 : 0.3})

d3.select(this.parentNode.parentNode).selectAll(".slopeLine").style("opacity", function(d,i) {return d3.select(this).attr("name") == laName ? 1 : 0})

d3.select(this.parentNode.parentNode).selectAll(".slopeLine").filter(function(d,i) {return d3.select(this).attr("name") == laName})
                                                .style("stroke", "orange")

d3.select(this.parentNode.parentNode).selectAll(".node").filter(function(d,i) {return d3.select(this).attr("name") == laName})
                                                .style("r", d3.select(this).attr("r")*1.5)
                                                .style("fill", "orange")

d3.select(this.ownerSVGElement).selectAll(".slopeLabelsGroup").selectAll("text").style("opacity", function(d,i) {return d3.select(this).attr("name") == laName ? 1 : 0})
                                                                                .attr("x", xPosition)
            
d3.select(this.ownerSVGElement).selectAll(".annotation1").attr("opacity", 0.1)

}

function handleMouseOut(e) {

d3.select(this.parentNode.parentNode).selectAll(".node").attr("opacity", null)

d3.select(this.parentNode.parentNode).selectAll(".node")
                                                .style("r", null)
                                                .style("fill", null)

d3.select(this.parentNode.parentNode).selectAll(".slopeLine").style("opacity", null).style("stroke", null)                                      

d3.select(this.ownerSVGElement).selectAll(".slopeLabelsGroup").selectAll("text").style("opacity", null).attr("x", null)

d3.select(this.ownerSVGElement).selectAll(".annotation1").attr("opacity", 1)


}


</script>

<g class="points">

    {#each data as point, i}

        {#if point["id"] == point["unique"] && visible}

            {#if point["id"] == "England"}

                <path
                class="node"
                transform={"translate("+point.x+","+point.y+")"}
                d={"M0 "+(-point.r)+" L"+point.r+" 0 L 0 "+point.r+" L "+(-point.r) +" 0 z" }
                fill={colors["england"][0]}
                stroke="none"
                name={null}
                ></path>

            {:else}

                <circle
                class="node"
                r={point.r}
                fill={colors["mainLA"][0]}
                cx={point.x}
                cy={point.y}
                name={null}
                ></circle>

        
            {/if}

        {:else}

            <circle on:mouseover={hoverLabel & visible ? handleMouseOver: null} on:focus={null} on:mouseleave={hoverLabel ? handleMouseOut: null}
            class={visible ? "node": null}
            r={visible ? point.r : 12}
            fill={visible ? colors["surroundingLAs"][0] : "white"}
            cx={point.x}
            cy={point.y}
            name={point["unique"]}
            ></circle>

        {/if}

    {/each}

</g>